<template>
  <div id="crew-list" class="h-full">
    <!-- 右上アクションボタン領域 -->
    <div class="flex flex-wrap justify-between items-center">
      <div class="flex w-1/3 justify-start pl-2">
        <div class="aisea-text-18-600-dark-gray">船員一覧</div>
      </div>
      <div class="flex w-2/3 justify-end items-center">
        <div class="flex justify-end items-center mr-5">
          <!-- 右上アクションボタン領域 -->
          <div
            class="list-type-button ml-2"
            :class="[
              listType === 'ALL'
                ? 'list-type-button--selected'
                : 'list-type-button--default',
            ]"
            style="cursor: pointer; word-break: keep-all"
            @click="selectFilterChip('ALL')"
          >
            全て
          </div>
          <div
            class="list-type-button ml-2"
            :class="[
              listType === 'ACTIVE_AND_ENABLED'
                ? 'list-type-button--selected'
                : 'list-type-button--default',
            ]"
            style="cursor: pointer; word-break: keep-all"
            @click="selectFilterChip('ACTIVE_AND_ENABLED')"
          >
            在職中
          </div>
          <div
            class="list-type-button ml-2"
            :class="[
              listType === 'ACTIVE_AND_DISABLED'
                ? 'list-type-button--selected'
                : 'list-type-button--default',
            ]"
            style="cursor: pointer; word-break: keep-all"
            @click="selectFilterChip('ACTIVE_AND_DISABLED')"
          >
            退職済
          </div>
        </div>
        <div
          ref="searchQueryBox"
          class="flex justify-end items-center mr-2"
          style="height: 3.2rem;"
        >
          <vs-tooltip text="検索" position="bottom">
            <div
              class="flex w-full justify-end items-center"
              style="position: relative;"
              @click="changeSearchQueryBoxWidth()"
            >
              <vs-input
                ref="incrementalSearch"
                icon="search"
                :placeholder="incrementalSearchPlaceholder"
                v-model="searchQueryString"
                @input="onSearchQueryUpdate"
                class="crew-incremental-search"
                :color="AISEA_COLOR.GRAY"
              />
              <vs-icon
                icon="clear"
                :color="AISEA_COLOR.GRAY"
                size="20px"
                style="position: absolute; right: 0.4rem;"
                :style="{ display: searchCondition.name ? 'block' : 'none' }"
                ref="incrementalSearchClear"
                @click="clearSearchQueryString"
              />
            </div>
          </vs-tooltip>
        </div>

        <vs-button
          icon="add"
          :color="AISEA_COLOR.BLUE"
          type="border"
          style="margin: 0 0.6rem; height: 2.7rem;"
          @click="showCrewSidebarForCreate(false)"
        >
          <span class="aisea-text-14-400-blue">新規登録</span>
        </vs-button>
      </div>
    </div>
    <vs-divider :color="AISEA_COLOR.LIGHT_GRAY" class="mt-2 mb-0" />

    <!-- AgGrid Table -->
    <ag-grid-vue
      ref="agGridTableCrewList"
      :gridOptions="gridOptions"
      @sortChanged="onSort"
      class="ag-theme-material w-full ag-grid-table"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="dispUsers"
      domLayout="autoHeight"
      rowSelection="multiple"
      colResizeDefault="shift"
      :animateRows="true"
      :floatingFilter="false"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :suppressPaginationPanel="true"
      :suppressDragLeaveHidesColumns="true"
      :suppressRowClickSelection="true"
      :suppressCellFocus="true"
      :suppressNoRowsOverlay="false"
      @grid-ready="onGridReady"
      @rowClicked="rowClicked"
      @bodyScroll="onBodyScroll"
    />

    <!-- 新規ボタン領域 -->
    <div id="crew-list-add-button" style="display: none; position: absolute;">
      <div class="flex w-full justify-center">
        <vs-button
          icon="add"
          :color="AISEA_COLOR.BLUE"
          type="border"
          style="margin: 0 0.6rem; height: 2.7rem;"
          @click="showCrewSidebarForCreate(false)"
          ><span class="aisea-text-14-400-blue">新規登録</span></vs-button
        >
      </div>
    </div>

    <!-- ページネーション領域 -->
    <div class="flex justify-end items-center" style="margin: 0.6rem 0;">
      <div style="margin-right: 2rem;">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2 aisea-text-12-400-black"
              >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }}
              -
              {{
                totalUser - currentPage * paginationPageSize > 0
                  ? currentPage * paginationPageSize
                  : totalUser
              }}
              / {{ totalUser }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="onChangePageSize(25)">
              <span class="aisea-text-12-400-black">25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="onChangePageSize(50)">
              <span class="aisea-text-12-400-black">50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="onChangePageSize(75)">
              <span class="aisea-text-12-400-black">75</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="onChangePageSize(100)">
              <span class="aisea-text-12-400-black">100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <div>
        <vs-pagination
          v-if="isReadyPagination"
          :total="totalPages"
          :max="7"
          v-model="currentPage"
          :color="AISEA_COLOR.BLUE"
        />
      </div>
    </div>

    <vs-prompt
      title="船員アカウント削除"
      type="confirm"
      :color="AISEA_COLOR.BLUE"
      accept-text="実行"
      cancel-text="キャンセル"
      :active.sync="showDeletePrompt"
      @accept="onDelete"
      @cancel="onDeleteCancel"
      class="crew-list-delete-confirm"
    >
      <div>
        {{ deleteDispName }}の登録情報を削除しますか？<br />
        削除したデータは戻せません。
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import Vue from "vue";
import _ from "lodash";
import FireStoreService from "@/services/fireStoreService";
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererRowActionButtons from "./cell-renderer/CellRendererRowActionButtons.vue";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseCrewApi = AiseaApiFactory.get("enterpriseCrew");

import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("crewList");
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  components: {
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererLink,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererRowActionButtons,
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    activeSidebarCrew: Boolean,
    activeTab: Number,
  },
  data() {
    return {
      listType: "ALL", // ALL, ACTIVE_AND_ENABLED, ACTIVE_AND_DISABLED
      users: [],
      crewBasicInfoParam: {},
      searchResult: {},
      searchQueryString: "",
      hoveredIdByRow: null,
      updatedIdList: [],
      showDeletePrompt: false,
      deleteDispName: "",
      incrementalSearchPlaceholder: "",
      actionButtonTimer: null,
      agGridScrollPosition: -1,

      pageable: {
        page: 0,
        total_elements: 0,
        total_pages: 1,
      },

      searchCondition: {
        name: "",
        active_type: "ACTIVE",
        sort_column: null,
        sort_order: null,
        page: 0,
        size: 50,
      },

      currentPage: 1,
      gridApi: null,
      gridOptions: {
        localeText: {
          noRowsToShow:
            '<div id="no-rows-crew-list" class="aisea-text-16-400-black">表示する船員基本情報がありません</div>',
        },
        context: {
          componentParent: this,
        },
      },
      pageSize: 50,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        icons: {
          sortAscending:
            '<span class="material-icons">keyboard_arrow_up</span>',
          sortDescending:
            '<span class="material-icons">keyboard_arrow_down</span>',
          sortUnSort: '<span class="material-icons">unfold_more</span>',
        },
        unSortIcon: true,
        comparator: () => {
          return;
        },
      },
      columnDefs: [],
      components: {
        CellRendererLink,
      },
      isReadyPagination: false,
      prevRoute: null,
    };
  },
  watch: {
    currentPage() {
      this.searchCondition.page = this.getCurrentPage();
      FireStoreService.setAccountSetting("crew_list", {
        current_page: this.currentPage,
      });
      this.searchUsers();
    },
    activeSidebarCrew(val) {
      if (!val) {
        document.getElementById("crew-list").click();
      }
    },
    dispUsers() {
      this.dispNoRows();
    },
  },
  computed: {
    ...mapState({
      laborTemplates: state => state.laborTemplates,
    }),
    sidebarStatus: {
      get() {
        return this.activeSidebarCrew;
      },
      set(val) {
        this.$emit("update:activeSidebarCrew", val);
      },
    },
    dispUsers() {
      return JSON.parse(JSON.stringify(this.users)).map(user => {
        user.birth_date = user.birth_date
          ? user.birth_date.replace(/-/g, "/")
          : null;
        user.exists_enterprise_crew_labor_select = user.enterprise_crew_labor_select
          ? "有"
          : "無";
        if (this.updatedIdList.includes(user.id)) {
          user.isUpdated = true;
        }
        return user;
      });
    },
    paginationPageSize() {
      return this.pageSize;
    },

    totalPages() {
      if (this.pageable) return this.pageable.total_pages;
      else return 0;
    },

    totalUser() {
      if (this.pageable) return this.pageable.total_elements;
      else return 0;
    },
    sortColumnList() {
      return this.columnDefs
        .filter(x => !["templateName"].includes(x.field))
        .map(x => x.field.toUpperCase());
    },
  },
  methods: {
    ...mapActions(["fetchAllLaborTemplates"]),

    selectFilterChip(activeType) {
      this.searchCondition["active_type"] = activeType;
      this.listType = activeType;
      this.searchUsers();
    },

    async onGridReady() {
      this.searchCondition.name = "";
      this.searchUsers();
    },

    reloadList() {
      this.searchQueryUpdate(this.searchQueryString, this);
    },
    onSearchQueryUpdate(val) {
      this.searchQueryString = val;
      this.currentPage = 1;
      this.searchQueryUpdate(val, this);
    },
    searchQueryUpdate: _.debounce(async (val, self) => {
      self.searchCondition.name = val;
      self.searchUsers();
    }, 800),

    async searchUsers() {
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      try {
        const res = await enterpriseCrewApi.search(this.searchCondition);
        this.users = res.data.enterprise_crews || [];
        Object.keys(res.data.pageable).forEach(key => {
          Vue.set(this.pageable, key, res.data.pageable[key]);
        });
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
      }
      this.$emit("checkAlert");
    },

    async restoreSearchCondition(userListSetting) {
      // TODO: firestore個人設定のリストア内容を再調整

      this.currentPage = 1;
      this.setPageSize(
        userListSetting && userListSetting.page_size
          ? userListSetting.page_size
          : 50
      );

      const searchCondition =
        userListSetting && userListSetting.search_condition
          ? userListSetting.search_condition
          : {};
      this.searchCondition = {
        ...this.searchCondition,
        name: searchCondition.name || "",
        page: this.getCurrentPage(),
        size: this.pageSize,
      };

      // currentPage は vs-pagination がロードされる前に初期値をセットしておく。
      this.isReadyPagination = true;
    },

    setPageSize(size) {
      this.pageSize = size;
      this.searchCondition.size = size;
      FireStoreService.setAccountSetting("crew_list", {
        page_size: this.pageSize,
      });
    },

    getCurrentPage() {
      return this.currentPage - 1;
    },

    onSort(object) {
      let sortColumn = object.columnApi.columnModel.viewportColumns.find(
        element => {
          return element.sort != null;
        }
      );
      const sortType = sortColumn ? sortColumn.sort.toUpperCase() : null;
      const sortColumnKey = sortColumn ? sortColumn.colId.toUpperCase() : null;
      this.searchCondition["sort_column"] = sortColumnKey;
      this.searchCondition["sort_order"] = sortType;
      this.currentPage = 1;
      this.reloadList();
    },

    showCrewSidebarForCreate(continueFlg) {
      this.crewBasicInfoParam = { id: null, continueFlg: continueFlg };
      this.$emit("setDialogTitle", "船員基本情報登録");
      this.sidebarStatus = true;
    },
    showCrewSidebarForEdit(data) {
      this.crewBasicInfoParam = data;
      this.$emit("setDialogTitle", "船員基本情報編集");
      this.sidebarStatus = true;
    },
    confirmDelete(data) {
      this.crewBasicInfoParam = data;
      this.deleteDispName = data.name;
      this.showDeletePrompt = true;
    },
    async onDelete() {
      this.showDeletePrompt = true;
      const targetData = this.dispUsers.find(
        x => x.id === this.crewBasicInfoParam.id
      );
      await enterpriseCrewApi.delete(targetData.id);
      console.debug("### 削除API", targetData.id);

      this.$vs.notify({
        title: `船員基本情報削除`,
        text: `${this.deleteDispName}の登録内容を削除しました`,
        color: "success",
        iconPack: "feather",
        icon: "icon-check",
      });
      this.$nextTick(() => {
        this.deleteDispName = "";
        this.reloadList();
        this.showDeletePrompt = false;
      });
    },
    onDeleteCancel() {
      this.showDeletePrompt = true;
      this.$nextTick(() => {
        console.debug("### onDeleteCancel", this.showDeletePrompt);
        this.deleteDispName = "";
        this.showDeletePrompt = false;
      });
    },

    onBodyScroll(e) {
      if (e.direction === "vertical") {
        this.agGridScrollPosition = e.top;
      }
    },

    dispNoRows() {
      const buttonEl = document.getElementById("crew-list-add-button");
      if (buttonEl && this.dispUsers.length === 0) {
        this.$nextTick(() => {
          const baseRect = document
            .getElementById("crew-list")
            .getBoundingClientRect();
          const noRowsEl = document.getElementById("no-rows-crew-list");
          if (noRowsEl) {
            const rect = noRowsEl.getBoundingClientRect();
            buttonEl.style.left = rect.x - baseRect.x + 40 + "px";
            buttonEl.style.top = rect.y - baseRect.y + 80 + "px";
            buttonEl.style.display = "block";
          } else {
            buttonEl.style.display = "none";
          }
        });
      } else if (buttonEl) {
        buttonEl.style.display = "none";
      }
    },

    closeSidebarCrew(continueFlg) {
      this.sidebarStatus = false;
      if (continueFlg) {
        this.$nextTick(() => {
          this.showCrewSidebarForCreate(continueFlg);
        });
      }
    },
    updatedId(id) {
      if (id && !this.updatedIdList.includes(id)) {
        this.updatedIdList.push(id);
      }
    },
    customizeCellStyle(params) {
      if (params.data.isUpdated) {
        return {
          backgroundColor: "lightyellow",
        };
      }
      return null;
    },

    rowClicked(e) {
      this.hoveredIdByRow = e.data.id;
      if (this.sidebarStatus) {
        this.sidebarStatus = false;
      }

      this.$nextTick(() => {
        this.$router.push({
          name: "enterprise-management-crew-profile",
          params: { id: this.hoveredIdByRow },
        });
      });
    },

    onChangePageSize(size) {
      this.setPageSize(size);
      this.currentPage = 1;
      this.$nextTick(() => {
        this.searchUsers();
      });
    },

    changeSearchQueryBoxWidth() {
      let inputEl = this.$refs.incrementalSearch.$el;
      if (inputEl) {
        inputEl.style.border = `1px solid ${this.AISEA_COLOR.BLUE}`;
        inputEl.style.width = "12rem";
        this.incrementalSearchPlaceholder = "氏名で検索";
        this.$nextTick(() => {
          inputEl.querySelector("input").focus();
        });
      }
    },

    clearSearchQueryString() {
      this.searchQueryString = "";
      this.reloadList();
    },
  },
  async beforeMount() {
    const initialColumnDefs = [
      {
        headerName: "氏名",
        field: "name",
        minWidth: 200,
        flex: 1,
        cellRenderer: "CellRendererLink",
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "氏名(カナ)",
        field: "name_kana",
        minWidth: 180,
        flex: 1,
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "生年月日",
        minWidth: 120,
        flex: 1,
        field: "birth_date",
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "電話番号",
        minWidth: 140,
        flex: 1,
        field: "phone_number",
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "メールアドレス(ID)",
        field: "email_address",
        minWidth: 240,
        flex: 1,
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "社員番号",
        minWidth: 120,
        flex: 1,
        field: "employee_number",
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "雇用形態",
        minWidth: 120,
        flex: 1,
        field: "employment_status",
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "所属企業",
        minWidth: 180,
        flex: 1,
        field: "affiliated_company",
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "組合員",
        minWidth: 120,
        flex: 1,
        field: "union_member",
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "操作",
        field: "action",
        minWidth: 70,
        maxWidth: 70,
        cellRendererFramework: "CellRendererRowActionButtons",
        pinned: "right",
        resizable: false,
        sortable: false,
        cellRendererParams: {
          edit: data => {
            this.showCrewSidebarForEdit(data);
          },
          delete: data => {
            this.confirmDelete(data);
          },
        },
        cellStyle: params => this.customizeCellStyle(params),
      },
    ];
    let columnDefs = [];
    const userListSetting = await FireStoreService.getAccountSetting(
      "crew_list"
    );
    if (
      userListSetting &&
      userListSetting.columns &&
      userListSetting.columns.length > 0
    ) {
      userListSetting.columns.forEach(columnId => {
        const columnDef = initialColumnDefs.find(
          columnDef => columnDef.field === columnId
        );
        if (columnDef) {
          columnDefs.push(columnDef);
        }
      });
    } else {
      columnDefs = initialColumnDefs;
    }
    this.columnDefs = columnDefs;
    this.pageSize =
      userListSetting && userListSetting.page_size
        ? userListSetting.page_size
        : 50;
    this.$nextTick(async () => {
      await this.restoreSearchCondition(userListSetting);

      await this.searchUsers();
    });
  },
  created() {
    this.fetchAllLaborTemplates();
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";

    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#crew-list {
  .vs-avatar--con-img img {
    object-fit: cover;
  }
  .ag-grid-table {
    height: 100%;

    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    .ag-header-cell-text {
      font-family: $aisea-font-family;
      font-size: 12px;
      font-weight: 600;
    }
    .ag-header-cell {
      padding-right: 0;
    }

    .ag-cell {
      padding-left: 10px;
      padding-right: 10px;
    }
    .ag-header-cell {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .ag-header-cell {
    padding-right: 0;
  }
  .vs-tabs--content {
    padding: 4px 0 0 0;
  }

  .list-type-button {
    display: flex;
    align-items: center;
    padding: 0 8px;
    height: 32px;
    border-radius: 15px;

    font-family: $aisea-font-family;
    font-size: 14px;

    &--selected {
      border: 1px solid $aisea-blue;
      padding-bottom: 4px;
      background-color: $aisea-blue;
      color: $aisea-pure-white;
      font-weight: 600;
      &:hover {
        background-color: #0277bd;
      }
    }
    &--default {
      border: 1px solid $aisea-light-gray;
      padding-bottom: 0px;
      background-color: none;
      color: none;
      font-weight: 400;
      &:hover {
        color: $aisea-blue;
        border-color: $aisea-blue;
      }
    }
  }

  .crew-incremental-search {
    border-radius: 6px;
    width: 2rem;
    transition: all 0.2s 0s ease;

    .vs-inputx {
      background-color: $aisea-pure-white;
      border: none !important;
      padding: 10px 0 8px 2rem !important;
      font-family: $aisea-font-family;
      font-size: 16px !important;
      font-weight: 400;
      color: $aisea-dark-gray;
    }
    .vs-input--icon {
      border-right-color: #ffffff00;
      margin-top: 0.2rem;
      font-size: 16px;
    }
    .vs-input--input:focus {
      box-shadow: 0 3px 10px 0 rgba($aisea-blue, 0.15);
    }
    .vs-input--placeholder {
      color: $aisea-light-gray !important;
      padding-left: 1.8rem !important;
      padding-top: 0.8rem !important;
    }
  }
  .vs-pagination--ul {
    span {
      font-size: 12px;
      font-family: $aisea-font-family;
      font-weight: 400;
    }
  }
  #crew-list-hover-menu {
    height: 0;
    right: 31px;

    .crew-list-hover-icon {
      border-radius: 4px;
      padding: 8px;
      &:hover {
        background-color: $aisea-light-white;
      }
    }
  }
}

.crew-list-delete-confirm {
  .vs-dialog-header {
    color: $aisea-black !important;
  }
}
</style>
